<script setup>
import AdvancedChartManager from '@/views/apps/chart/list/AdvancedChartManager.vue';

definePage({
  meta: {
    action: 'read',
    subject: 'dashboard',
  },
})
</script>

<template>
  <section>
    <AdvancedChartManager/>
  </section>
</template>
